import { IsNotEmpty } from 'class-validator';
import { Mapper } from '../../../../common/ddd/mapper.base';
import { IOrgWorkingSessionsAnalyticsActivityEnum } from '../../../../common/enum/working-sessions/org-working-sessions-analytics-activity.enum';
import { AccountAverageWorkingHoursSummaryEntity } from '../../../../core/domain/entities/org-metrics/working-hours/account-average-working-hours-summary.entity';

export class IAccountAverageWorkingHoursSummaryPersistenceResponse {
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.UserId]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.LocalSessionStartDate]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.TotalDuration]: string;
}

export class AccountAverageWorkingHoursSummaryMapper
  implements
    Omit<Mapper<AccountAverageWorkingHoursSummaryEntity, any>, 'toResponse'>
{
  toDomain(
    record: IAccountAverageWorkingHoursSummaryPersistenceResponse
  ): AccountAverageWorkingHoursSummaryEntity {
    return AccountAverageWorkingHoursSummaryMapper.toDomain(record);
  }
  static toDomain(
    record: IAccountAverageWorkingHoursSummaryPersistenceResponse
  ): AccountAverageWorkingHoursSummaryEntity {
    const entity = AccountAverageWorkingHoursSummaryEntity.create({
      duration: Number(
        record[IOrgWorkingSessionsAnalyticsActivityEnum.TotalDuration]
      ),
      userId: String(record[IOrgWorkingSessionsAnalyticsActivityEnum.UserId]),
      date: new Date(
        record[IOrgWorkingSessionsAnalyticsActivityEnum.LocalSessionStartDate]
      ),
    });
    return entity;
  }
}
